import * as yup from 'yup'

export const validateCreatePricesList = yup.object().shape({
    name:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'El NOMBRE debe tener más de 2 caracteres'),
    description:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'LA DESCRIPCIÓN debe tener más de 2 caracteres'),
    start_at:yup
    .string(),
    // .required('Campo requerido.'),
    ends_at:yup
    .string(),
    // .required('Campo requerido.'),
    // status: yup
    // .string()
    // .required('Campo requerido.')
    // .oneOf(['active', 'inactive'], 'Debes elegir entre estas opciones'),
    priority:yup
    .number().typeError('Campo requerido.')
    .positive()
    .required('Campo requerido.')
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    prices: yup.array()
    .required('Campo requerido.')
    .of(
      yup.object().shape({
        product_id: yup.number().typeError('Campo requerido.'),
        price: yup.number().typeError('Campo requerido.'),
      })
    ),
    customer_groups: yup.array()
    .of(
      yup.object().shape({
        customer_group_id: yup.number().typeError('Campo requerido.')
      })
    ),
})